exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ModalMask {\n  position: fixed;\n  z-index: 1040;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  transition: all 0.3s ease;\n  overflow-x: hidden;\n  overflow-y: auto;\n  opacity: 1;\n  -webkit-overflow-scrolling: touch;\n}\n.ModalMask.modal-enter-active:not(.\\--restored) {\n  transition: all 0.2s ease;\n  opacity: 0;\n}\n.ModalMask.modal-enter-active:not(.\\--restored).modal-enter-to {\n  opacity: 1;\n}\n.ModalMask.modal-leave-active {\n  transition: all 0.2s ease;\n  opacity: 1;\n}\n.ModalMask.modal-leave-active.modal-leave-to {\n  opacity: 0;\n}\n", ""]);

// exports
